import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type ConversationViewModel } from '@/features/messaging/ConversationViewModel'
import {
  Welcome,
  type WelcomeAction,
} from '@/features/messaging/components/ConversationView/Messages/Welcome'

export interface WelcomeContainerProps {
  vm: ConversationViewModel
  small?: boolean
  welcomeActions?: WelcomeAction[]
}

export const WelcomeContainer = observer(function WelcomeContainer({
  vm,
  small,
  welcomeActions,
}: WelcomeContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <Welcome
      corporateMode={shellInfo.corporateMode}
      allMessagesLoaded={vm.scroller.isDone}
      loadFailed={!vm.scroller.fetch.pending && vm.scroller.fetch.rejected}
      loadError={vm.scroller.fetch.error}
      onRetry={vm.scroller.fetch}
      small={small}
      welcomeActions={welcomeActions}
    />
  )
})
